import { localPageComponents } from "../local/registry-page";

export const clayBuckPageComponents = {
  ...localPageComponents,
};
